import React, { useState } from 'react';
import { __ } from 'first-intl';
import { RadioButtonOption, RadioGroup } from '@hugendubel/react-basic';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { AddPrivateAddressForm } from './AddPrivateAddressForm';
import { AddCompanyAddressForm } from './AddCompanyAddressForm';

type FormType = 'private' | 'company';
const FORM_TYPE_PRIVATE = 'private';
const FORM_TYPE_COMPANY = 'company';

export type AddAddressFormProps = { onClose: () => void };

const FORM_TYPE_OPTIONS: ReadonlyArray<RadioButtonOption<FormType>> = [
    { label: { id: 'form.addAddress.formType.private' }, value: FORM_TYPE_PRIVATE },
    { label: { id: 'form.addAddress.formType.company' }, value: FORM_TYPE_COMPANY },
];

export const AddAddressForm = ({ onClose }: AddAddressFormProps) => {
    const [formType, setFormType] = useState<FormType>(FORM_TYPE_PRIVATE);

    return (
        <div className="newAddress">
            <p>
                <strong>{__('form.addAddress.title')}</strong>
            </p>
            <div className="row">
                <div className="col col-xs-12 address-types">
                    <RadioGroup
                        trackId={TRACK_ID('2019-07-31 06:10:15')}
                        className="option-row simple wrap"
                        optionClass="radio-right"
                        value={formType}
                        onChange={setFormType}
                        options={FORM_TYPE_OPTIONS}
                    />
                </div>
            </div>
            {formType === FORM_TYPE_PRIVATE ? (
                <AddPrivateAddressForm onClose={onClose} />
            ) : (
                <AddCompanyAddressForm onClose={onClose} />
            )}
        </div>
    );
};
